<template>
    <div class="row"  style="padding-top: 200;text-align: center;width: 100%; height: 100%;position: absolute; top: 0; left: 0">
      <h1 style="color: green;">  جارى نقل الموقع</h1>
       <br>
     <img :src="image" class="center"/>
      <br>
      <h2 style="color: green;">سنعود قريبا</h2>
    </div>
</template>
<style media="screen">
.center {
display: block;
margin-left: auto;
margin-right: auto;
width: 350;
height: 250;

}
</style>
<script>
import image from '@/assets/under_construction.png'
import ramadanimage from '@/assets/ramadanstyle.png'
export default {
  name: 'SiteUnderMaintenance',
  data () {
    return {
      image: image,
      ramadanimage: ramadanimage
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/SiteUnderMaintenance.vue